import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl-next';

import { Bolded, EndOfTrialModalText } from '../styled/StyledModal';
import { useGetFeaturesUsed } from '../hooks/useGetFeaturesUsed';
import { useUserInfo } from '../store/userInfoStore';

const i18n = defineMessages({
	usedSomeFeatures: {
		id: 'end-of-trial-payment-modals.standard.features-used.7-days-left.some',
		defaultMessage:
			'Your team has used <b>{used, number}</b> out of <b>{total, number}</b> Standard features during your trial. Keep exploring the remaining features.',
		description: 'When the trial ends in 7-4 days, and have used some features',
	},
	usedAllFeatures: {
		id: 'end-of-trial-payment-modals.standard.features-used.7-days-left.all',
		defaultMessage:
			'Your team has used all of Standard‘s top features during the trial. Add payment to keep them after the trial ends.',
		description: 'When the trial ends in 7-4 days, and have used all features',
	},
	fewDaysLeft: {
		id: 'end-of-trial-payment-modals.standard.features-used.3-or-2-days-left',
		defaultMessage: 'Add payment to keep Standard features after your trial.',
		description: 'When the trial ends in 3-2 days',
	},
	oneDayLeft: {
		id: 'end-of-trial-payment-modals.standard.features-used.1-day-left',
		defaultMessage:
			'Add payment details to keep using advanced features after your Standard trial ends.',
		description: 'When the trial ends tomorrow',
	},
});

// we probably want to do something to make sure the number is between 1 and 4
export const EndOfTrialSubtitle = () => {
	const { daysLeftInTrial } = useUserInfo();
	const featuresUsed = useGetFeaturesUsed();

	if (daysLeftInTrial === 1) {
		return (
			<Bolded>
				<EndOfTrialModalText>
					<FormattedMessage {...i18n.oneDayLeft} />
				</EndOfTrialModalText>
			</Bolded>
		);
	}

	if (daysLeftInTrial === 2 || daysLeftInTrial === 3) {
		return (
			<Bolded>
				<EndOfTrialModalText>
					<FormattedMessage {...i18n.fewDaysLeft} />
				</EndOfTrialModalText>
			</Bolded>
		);
	}

	if (featuresUsed === 4) {
		return (
			<Bolded>
				<EndOfTrialModalText>
					<FormattedMessage {...i18n.usedAllFeatures} />
				</EndOfTrialModalText>
			</Bolded>
		);
	}

	return (
		<EndOfTrialModalText>
			<FormattedMessage
				{...i18n.usedSomeFeatures}
				values={{
					used: featuresUsed,
					total: 4,
					b: (chunks: React.ReactNode[]) => <Bolded>{chunks}</Bolded>,
				}}
			/>
		</EndOfTrialModalText>
	);
};
